import { render, staticRenderFns } from "./task-note.vue?vue&type=template&id=dbc5f0d8&scoped=true&"
import script from "./task-note.vue?vue&type=script&lang=ts&"
export * from "./task-note.vue?vue&type=script&lang=ts&"
import style0 from "./task-note.vue?vue&type=style&index=0&id=dbc5f0d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc5f0d8",
  null
  
)

export default component.exports